var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9183 12.7783L21.2217 14.0817L8.38667 26.9167H7.08333V25.6133L19.9183 12.7783ZM25.0183 4.25C24.6642 4.25 24.2958 4.39167 24.0267 4.66083L21.4342 7.25333L26.7467 12.5658L29.3392 9.97333C29.8917 9.42083 29.8917 8.52833 29.3392 7.97583L26.0242 4.66083C25.7408 4.3775 25.3867 4.25 25.0183 4.25ZM19.9183 8.76917L4.25 24.4375V29.75H9.5625L25.2308 14.0817L19.9183 8.76917Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b99ed33400fe1869bc27ed06e6faa4fe.svg";
export { ForwardRef as ReactComponent };